import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';

interface ArticleSublayoutProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: ArticleSublayoutProps) => {
  return props?.rendering && <Placeholder name="article-sublayout" rendering={props?.rendering} />;
};
